export const SET_LOADER = 'SET_LOADER';
export const REMOVE_LOADER = 'REMOVE_LOADER';

export const SET_ERROR = 'SET_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const SET_NOTIFY = 'SET_NOTIFY';
export const REMOVE_NOTIFY = 'REMOVE_NOTIFY';

export const HEADER_FOOTER_VISIBILITY = 'HEADER_FOOTER_VISIBILITY';
export const MENU_VISIBILITY = 'MENU_VISIBILITY';
